import {ARTIST_SAVE, ADMIN_CHANGE_ARTIST, ARTIST_NAME_SAVE} from '../app/constant'

const INITIAL_STATE = {
  artists: []
}

export default function artistReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ARTIST_SAVE:
      return {
        ...state,
        artists: action.artists
      }
    case ADMIN_CHANGE_ARTIST:
      return {
        ...state,
        adminArtists: action.info
      }
    case ARTIST_NAME_SAVE:
      return {
        ...state,
        artistNames: action.artistNames
      }
    default:
      return state
  }
}
